export enum PageTypesEnum {
    CDSS = 'cdss',
    CTMS = 'ctms',
    ADMIN = 'admin',
    CDSSADMIN = 'cdssadmin',
}
